import React from "react";

const PlusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" height="28" width="28">
      <defs />
      <path fill="#35144f" d="M101 23a74 74 0 1074 74 74 74 0 00-74-74zm0 141a67 67 0 1167-67 67 67 0 01-67 67z" />
      <path fill="#35144f" d="M131 94h-27V67a3 3 0 10-6 0v27H71a3 3 0 000 6h27v27a3 3 0 106 0v-27h27a3 3 0 100-6z" />
    </svg>
  );
};

export default PlusIcon;
